import { useHistory } from "react-router-dom";
import { getInternalPath } from "../utils";

export default (source, routes) => {
	const history = useHistory();
	const isSearchPage = history.location.pathname === getInternalPath(source, routes.SEARCH);
	const isPurchasePage = history.location.pathname === getInternalPath(source, routes.PURCHASE);
	return { isSearchPage, isPurchasePage };
};
